import type { SupabaseClient } from "@supabase/supabase-js";
export type AppRole = "admin" | "manager" | "staff" | null;

export async function fetchUserRole(supabase: SupabaseClient): Promise<AppRole> {
  const { data, error } = await supabase
    .from("current_user_role")
    .select("role")
    .single();

  if (error) {
    console.warn("fetchUserRole error:", error.message);
    return null;
  }
  return (data?.role ?? null) as AppRole;
}